import { z } from 'zod';

const MarketingPreferenceSchema = z.object({
  BrokerageId: z.string().uuid(),
  ClientId: z.number(),
  MarketingByEmail: z.boolean().nullable(),
  MarketingBySms: z.boolean().nullable(),
  MarketingByPost: z.boolean().nullable(),
  MarketingByPhone: z.boolean().nullable(),
  UpdatedBy: z.string(),
});

export const MarketingPreferencesSchema = z.array(MarketingPreferenceSchema);

const UpdateMarketingPreferencesRequestSchema = z.object({
  clientId: z.number(),
  marketingByEmail: z.boolean(),
  marketingBySms: z.boolean(),
  marketingByPost: z.boolean(),
  marketingByPhone: z.boolean(),
});

export type MarketingPreference = z.infer<typeof MarketingPreferenceSchema>;
export type MarketingPreferencesResponse = z.infer<typeof MarketingPreferencesSchema>;
export type UpdateMarketingPreferencesRequest = z.infer<typeof UpdateMarketingPreferencesRequestSchema>;

export { MarketingPreferenceSchema, UpdateMarketingPreferencesRequestSchema };